import { render, staticRenderFns } from "./copperateInput.vue?vue&type=template&id=18f32454&scoped=true&"
import script from "./copperateInput.vue?vue&type=script&lang=js&"
export * from "./copperateInput.vue?vue&type=script&lang=js&"
import style0 from "./copperateInput.vue?vue&type=style&index=0&id=18f32454&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f32454",
  null
  
)

export default component.exports